import { Attribute } from "../../../../../../model/service-request/attribute";
import styles from "./FieldPerSubtypePayment.module.scss";
import { useDispatch } from "react-redux";
import { resetAllOptionAmounts, updateOptionAmount } from "../../../../../../stores/slices/service-type-slice";
import { CircleCheckIcon } from "../../../../../../assets/icons";

interface FieldPerSubtypePaymentProps {
    field: Attribute;
    fieldIndex: number;
    isExpanded: boolean;
    sectionIndex:number;
    onDropdownClick: () => void;
}

const FieldPerSubtypePayment: React.FC<FieldPerSubtypePaymentProps> = ({ field, fieldIndex,isExpanded,onDropdownClick ,sectionIndex}) => {
    const dispatch = useDispatch();

    const handleChange = (e: any, optionIndex: number) => {
        dispatch(updateOptionAmount({amount: e.target.value, fieldIndex: fieldIndex, optionIndex: optionIndex,sectionIndex:sectionIndex}))
    }

    return (
        <div className={`${styles.contentContainer} ${isExpanded ? styles.selectedOption :""}`}>
            {isExpanded && <CircleCheckIcon className={styles.checkIcon}/>}
            <div className={styles.labelContainer} onClick={() => {
                if(!isExpanded){
                    dispatch(resetAllOptionAmounts());
                    onDropdownClick();
                }
                }}>
                <label>{field.label}</label>
            </div>
            {isExpanded &&
                <>
                    <div className={styles.noteWrapper}>
                        <span>Input price for various type</span>
                    </div>
                    {field.childrenOptionDefinitions?.map((option, index) => (
                        <div key={index} className={styles.subtypeItemContainer}>
                            <label>{option.value}</label>
                            <div className={styles.amountInputContainer}>
                                <input type="number" placeholder="0.00" value={option.price?.amount} onChange={(e) => handleChange(e, index)} />
                                <span>NGN</span>
                            </div>
                        </div>
                    ))}

                </>
            }
        </div>
    )
}

export default FieldPerSubtypePayment;